import React from 'react';
import classes from './google_button.module.css';
import google_logo_SI from '../../../images/Google_logo_SI@4x.png';

function GoogleButton({ handleButtonClick, 'data-testid': dataTestId, ...props }) {
  return (
    <button 
      className={classes['google-button']} 
      onClick={handleButtonClick}
      aria-label="Sign in with Google"
      data-testid={dataTestId}
      {...props}
    >
      <img src={google_logo_SI} alt="Google Logo" />
    </button>
  );
}

export default GoogleButton;